<template>
  <v-container fluid fill-height class="pa-0">
    <v-layout class="pa-0" row>
      <v-dialog
        v-model="showMessageGeofence"
        max-width="450"
        persistent
      >
        <edit-geofence-message
          @centerPolygon="centerPolygon"
          @clearFenceSelected="clearFenceSelected"
          @cancelEdit="cancelEdit"
          :editedPath="editedPath"
        />
      </v-dialog>
      <v-snackbar
        v-model="snackbarAlert"
        :timeout="timeoutSnackbar"
        :top="true"
        color="error"
      >
        {{ messageTextSnackbar }}
        <v-btn
          color="white"
          flat
          @click="snackbarAlert = false"
        >
          Cerrar
        </v-btn>
      </v-snackbar>
      <v-flex>
        <!-- OFFICIAL FENCES -->
        <v-flex
          class="menu-container"
          ma-2
          d-inline-flex
          align-center
        >
          <v-flex class="title-1 text-xs-right" pl-1 pt-1>
            <h2>Cercas Oficiales</h2>
          </v-flex>
          <v-flex d-inline-flex pl-3 pt-2>
            <v-autocomplete
              v-if="showMedellinZones"
              v-model="selectedOficialFence"
              label="Barrio"
              class="mx-1"
              :items="neighborhoods"
              item-text="name"
              box
              :return-object="true"
              color="white"
              menu-props="{maxHeight : '500'}"
              @input="handleDisplayFence('Barrio')"
            />
            <v-autocomplete
              v-if="showMedellinZones"
              v-model="selectedOficialFence"
              label="Comuna"
              class="mx-1"
              :items="comunes"
              item-text="name"
              box
              :return-object="true"
              color="white"
              menu-props="{maxHeight : '500'}"
              @input="handleDisplayFence('Comuna')"
            />
            <v-autocomplete
              v-model="selectedOficialFence"
              label="Cuadrante"
              class="mx-1"
              :items="quadrants"
              item-text="name"
              box
              :return-object="true"
              color="white"
              menu-props="{maxHeight : '500'}"
              @input="handleDisplayFence('Cuadrante')"
            />
            <v-autocomplete
              v-model="selectedOficialFence"
              label="Estación"
              class="mx-1"
              :items="stations"
              item-text="name"
              box
              :return-object="true"
              color="white"
              menu-props="{maxHeight : '500'}"
              @input="handleDisplayFence('Estación')"
            />
            <v-autocomplete
              v-if="showMedellinZones"
              v-model="selectedOficialFence"
              label="Distrito"
              class="mx-1"
              :items="districts"
              item-text="name"
              box
              :return-object="true"
              color="white"
              menu-props="{maxHeight : '500'}"
              @input="handleDisplayFence('Distrito')"
            />
          </v-flex>
        </v-flex>
        <!-- TITLE  -->
        <v-flex 
          v-if="showTitle" 
          class="text-xs-center title-2"
          :class="[selectedItem.length > 0 ? title2Left2 : title2Left1]"
          d-inline-flex
          align-center
          pa-2
          ma-2
        >
          <v-flex>
            <h2>
              <span>{{ selectedType }}:</span> {{ selectedName }}
            </h2>
          </v-flex>
          <v-flex v-if="!editingGeofence" pl-3>
            <v-btn
              class="caption"
              color="primary"
              dark
              fab
              small
              @click="clearFenceSelected"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex v-if="editingGeofence" class="tag-container caption font-weight-bold" ml-3 px-3 py-1>
            Editando
          </v-flex>
        </v-flex>
        <v-flex d-flex>
          <!-- LEFT SIDE -->
          <v-layout
            v-if="selectedItem.length > 0"
            class="container-left" 
            ml-2 
            wrap 
            justify-space-around>
            <v-flex pa-2>
              <h2>Cercas Oficiales Seleccionadas</h2>
            </v-flex>
            <v-flex
            v-for="(item, index) in selectedItem"
            :key="index">
            <v-flex>
              <v-chip 
                v-model="chipsModel[index]"
                @input="chipHandle(index)"
                @click="clickChip(index)"
                close>
                <v-avatar class="blue white--text"><b>{{ avatarChip[index] }}</b></v-avatar>
                {{ item.name }}
              </v-chip>
            </v-flex>
            </v-flex>
          </v-layout>
          <!-- MAP -->
          <v-flex mx-2>

            <gmap-map
              class="map-container"
              :center="center"
              :zoom="zoom"
              ref="fencesMap"
              :options="mapOptions"
            >
              <!-- :path="newPath.getArray()" -->
              <GmapPolygon
                v-if="newPath.length !== 0 && showCreateEditGeofence"
                :path="newPath"
                editable
                :options="{strokeColor:'#263238', fillColor:'#263238'}"
                @path_changed="newPathChanged"
              />
              <GmapPolygon
                v-if="selectedGeofence !== null"
                :editable="editingGeofence"
                :path="selectedGeofence.path"
                :options="editingGeofence ? {strokeColor:'#FFC400', fillColor:'#FFC400'} : {strokeColor:'#FF3D00', fillColor:'#FF3D00'}"
                @path_changed="updateEdited($event)"
              />
              <!-- v-if="stackGeofence !== null" -->
              <GmapPolygon
                v-for="geofence in stackGeofence"
                :key="geofence.id"
                :paths="geofence.path"
                :options="{strokeColor:'#283593', fillColor:'#283593'}"
              />
            </gmap-map>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- FENCES LIST -->
      <v-flex
        pt-2
        pr-2
        class="list-container"
      >
        <list-geofences
          @cancelEdit="cancelEdit"
          @centerPolygon="centerPolygon"
          @showPolygonTools="showPolygonTools"
          @hidePolygonTools="hidePolygonTools"
          @handleDoneClick="handleDoneClick"
          @cancelCreate="cancelCreate"
          :newPath="newPath"
          :editedPath="editedPath"
        />
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
  import Vue from 'vue'
  import * as types from '../store/mutations-types'
  import {mapActions, mapGetters} from 'vuex'
  import mapOptions from '../utils/mapOptions'
  // import {loaded} from 'vue2-google-maps'
  import zoomMapBoundaries from '../utils/zoomMapBoundaries'

  import ListGeofences from './Geofence/ListGeofences'
  import EditGeofenceMessage from './Geofence/EditGeofenceMessage'
  import { editGeofenceMixin } from '../mixins/editGeofenceMixin'
  /**
   * Componente que sirve como base para la ruta `/fences`
   *
   * @author Manuel Ochoa
   */
  export default {
    name: 'base-geofences',
    mixins: [editGeofenceMixin],
    components: {
      ListGeofences,
      EditGeofenceMessage
    },
    data() {
      return {
        pathChanged: false,
        editedPath: [],
        newName: '',
        title2Left1: 'title-2-left-1',
        title2Left2: 'title-2-left-2',
        messageTextSnackbar: '',
        snackbarAlert: false,
        timeoutSnackbar: 6000,
        zoom: 12,
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        mapOptions,
        selectedType: '',
        selectedName: '',
        itemSelected: '',
        selectedOficialFence: {},
        selectedItem: [],
        showTitle: false,
        chipsModel: [],
        counterChips: 0,
        avatarChip: [],

        /**
         * Array de posiciones que describe un poligono en Google Maps
         * @type {array}
         */
        newPath: [],
        mapClickListener: null
      }
    },
    watch: {
      geofenceUpdated(newValue) {
        if (newValue === 'error') {
          this.timeoutSnackbar = 0
          this.messageTextSnackbar = `Se debe usar un nombre diferente para la Geocerca que esta Editando.`
          this.snackbarAlert = true
        }
      },
      geofenceCreated(newValue) {
        if (newValue === 'error') {
          this.timeoutSnackbar = 0
          this.messageTextSnackbar = `Se debe usar un nombre diferente para la Geocerca. ${this.newName} esta en uso.`
          this.snackbarAlert = true
          // this.setGeofenceCreated('idle')
        }
      },
      newPath(newValue, oldValue) {
        // console.log('NEW PATH: ', newValue, oldValue)
      },
      selectedGeofence(newValue, oldValue) {
        if (newValue === null) this.showTitle = false
        else {
          this.$nextTick(() => {
            this.selectedType = 'Cerca'
            this.selectedName = newValue.name
            this.showTitle = true
            let bounds = new google.maps.LatLngBounds()
            // console.log('NEW VALUE', newValue)
            newValue.path.map(bound => {
              bounds.extend(bound)
            })
            const area = zoomMapBoundaries(bounds)
            if (area > 100000) {
              // console.log('Area BG > 100000')
              this.$refs.fencesMap.fitBounds(bounds)
            } else {
              const extraPadding = 350
              // console.log('Area BG <= 100000')
              this.$refs.fencesMap.fitBounds(bounds, extraPadding)
              // this.mapOptions.zoom = 17
            }
            // this.centerPolygon(newValue)
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole',
        role: 'auth/role',
        geofences: 'getGeofences',
        selectedGeofence: 'getSelectedGeofence',
        neighborhoods: 'filters/getNeighborhoods',
        comunes: 'filters/getComunes',
        quadrants: 'filters/getQuadrants',
        stations: 'filters/getStations',
        districts: 'filters/getDistricts',
        clientId: 'auth/clientId',
        mapZoneMode: 'auth/mapZoneMode'
      }),
      showMedellinZones() {
        return this.mapZoneMode !== 'gobernacion'
      },
      ...mapGetters([
        'geofenceUpdated',
        'editingGeofence',
        'geofenceCreated',
        'stackGeofence',
        'showCreateEditGeofence',
        'showMessageGeofence',
        'missionsTemplates'
      ])
    },
    methods: {
      ...mapActions([
        // 'setGeofenceUpdated',
        // 'setGeofenceCreated',
        'deselectFence',
        'fetchGeofencesData',
        'selectGeofence',
        'createGeofence',
        'showCreateEditGeofenceAction',
        'fetchMissionsTemplates'
      ]),
      cancelEdit() {
        this.editedPath = []
        this.pathChanged = false
        this.clearFenceSelected()
      },
      updateEdited(mvcArray) {
        // console.log('PATH EDITED!')
        if (!this.pathChanged) {
          this.pathChanged = true
        }
        this.editedPath = mvcArray.getArray()
      },
      newPathChanged(mvcPath) {
        // `path_changed` entrega un MVCArray de google.maps.LatLng.
        // Usamos la API pública getArray() (antes se leía la propiedad
        // interna minificada `.je`, que dejó de existir en versiones nuevas).
        this.newPath = mvcPath.getArray()
      },
      // featureAdded(e) {
      //   const type = e.feature.getGeometry().getType()
      //   if (type === 'Polygon') {
      //     this.addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())
      //   }
      // },
      // someFunction() {
      //   console.log('SOME FUNCTION!')
      // },
      // addFeature(type, path) {
      //   console.log('ADD FEATURE', type, path)
      //   if (type === 'Polygon') {
      //     console.log('POLYGON')
      //     const polygon = new google.maps.Polygon()
      //     // polygon.setPath(path)
      //     this.newPath = path.getArray()
      //     // this.newPath = path
      //     polygon.setPath(this.newPath)

      //     polygon.getPath().addListener('insert_at', this.someFunction)
      //     polygon.getPath().addListener('set_at', this.someFunction)
      //   }
      // },
      clearFenceSelected() {
        this.showTitle = false
        this.zoom = 13
        this.center = {
          lat: 6.254790211409118,
          lng: -75.551029793457
        }
        Vue.set(this.$refs.fencesMap.options, 'center', this.center)
        this.deselectFence()
      },
      cancelCreate() {
        // console.log('CANCEL CREATE EMITED!!!')
        this.showCreateEditGeofenceAction(false)
        this.hidePolygonTools()
      },
      /**
       * Metodo que crea la GeoCerca con una llamada al action `createGeofence()`
       */
      async handleDoneClick(dataIn) {
        const newName = dataIn.newName
        this.newName = newName
        // console.log('NEW PATH', this.newPath)
        // console.log('NEW NAME', newName)
        if (this.newPath.length === 0 || newName === '') {
          // console.log('NO DATA')
          this.messageTextSnackbar = 'ERROR: Se debe crear un polígono valido en el mapa!'
          this.snackbarAlert = true
          this.cancelCreate()
          return
        }
        // this.loadingDone = true
        let agencies = []
        if (this.adminRole === 400 || this.adminRole === 500) agencies.push(dataIn.agencies)
        else agencies = this.role
        const data = await this.createGeofence({ name: newName, path: this.newPath, agencies })
        // console.log('DATA NEW GEOFENCE', data)
        this.newPath = []
        this.newName = ''
        // console.log('CREATED GEOFENCE AFTER', data)
        // .then(fence => {
        // this.loadingDone = false
        // this.$router.back()
        this.cancelCreate()
        // })
      },
      hidePolygonTools() {
        if (this.mapClickListener) {
          google.maps.event.removeListener(this.mapClickListener)
          this.mapClickListener = null
        }
        this.newPath = []
      },
      showPolygonTools() {
        // DrawingManager fue removido de la Maps JS API en la v3.65
        // (https://developers.google.com/maps/deprecations). En su lugar se
        // dibuja el polígono manualmente: cada click en el mapa agrega un
        // vértice a `newPath`, que renderiza el <GmapPolygon> editable de la
        // plantilla. El usuario puede arrastrar los vértices para ajustar.
        this.newPath = []
        const mapObject = this.$refs.fencesMap.$mapObject
        // Se reasigna el array (no push) para que el watcher de `path`
        // (deep: false) en vue2-google-maps detecte el cambio y redibuje.
        this.mapClickListener = mapObject.addListener('click', (event) => {
          this.newPath = [...this.newPath, event.latLng]
        })
      },
      clickChip(index) {
        // console.log('CLICK ON CHIP', index)
      },
      chipHandle(index) {
        // console.log('CHIP:', index)
        this.counterChips--
        this.selectedItem.splice(index, 1)
        this.chipsModel.splice(index, 1)
        this.avatarChip.splice(index, 1)
        // console.log('SELECTED ITME:', this.selectedItem)
        // console.log('CHIP MODEL:', this.chipsModel)
        this.$store.commit(types.REMOVE_STACK_GEOFENCE, index)
      },
      /**
       * Centra la geocerca seleccionada en el mapa de geocercas
       *
       * @param fence
       * @returns {Promise<void>}
       */
      async centerPolygon(fence, type = 'Cerca') {
        if (type === 'Cerca') this.selectedOficialFence = {}
        this.showTitle = true
        this.selectedType = type
        this.selectedName = fence.name
        // await loaded
        let bounds = new google.maps.LatLngBounds()
        // console.log('THIS SELECTED GEOFENCE', this.selectedGeofence)
        this.selectedGeofence.path.map(bound => {
          bounds.extend(bound)
        })
        this.$nextTick(() => {
          const area = zoomMapBoundaries(bounds)
          if (area > 100000) {
            // console.log('Area cP > 100000')
            this.$refs.fencesMap.fitBounds(bounds)
          } else {
            const extraPadding = 350
            // console.log('Area cP <= 100000')
            this.$refs.fencesMap.fitBounds(bounds, extraPadding)
            // this.mapOptions.zoom = 17
          }
        })
      },
      handleDisplayFence(type) {
        const index = this.selectedItem.findIndex(item => item.id === this.selectedOficialFence.id)
        // console.log('Index', index)
        if (index !== -1) {
          this.selectedOficialFence = {}
          return
        }

        this.chipsModel[this.counterChips] = true
        this.counterChips++
        this.avatarChip.push(type.slice(0, 2))
        const path = window.google.maps.geometry.encoding.decodePath(this.selectedOficialFence.geostring)
        this.selectedOficialFence.path = path
        // this.selectGeofence(this.selectedOficialFence)
        this.$store.commit(types.ADD_STACK_GEOFENCE, this.selectedOficialFence)
        this.selectedItem.push(this.selectedOficialFence)
        this.selectedOficialFence = {}
        // console.log('SELECTED ITME 1:', this.selectedItem)
        // console.log('CHIP MODEL 1:', this.chipsModel)
        // this.centerPolygon(this.selectedOficialFence, type)
      }
    },
    created() {
      this.$store.commit(types.SELECT_GEOFENCE, null)
      if (this.missionsTemplates.length === 0) this.fetchMissionsTemplates()
    },
    /**
     * Carga la información de las geocercas desde micro de GEO
     */
    mounted() {
      if (this.geofences.length === 0) this.$store.dispatch('fetchGeofencesData')
    }
  }
</script>

<style lang="stylus" scoped>
span
  color silver

.tag-container
  color #424242
  background-color #FFC400
  border-radius 24px

.list-container
  min-width 350px
  max-width 350px
  height 100%

.map-container
  width 100%
  height calc(100vh - 155px)

.title-1
  max-width 100px
  min-width 100px

.title-2
  position: absolute;
  top: 100px;
  z-index: 5;
  height 55px
  border-radius 3px
  background-color #212121

.title-2-left-1
  left: 10px;

.title-2-left-2
  left: 350px;

.menu-container
  max-height 85px
  border-radius 3px
  background-color #212121

.container-left
  max-width 330px
  // min-width 330px
  height 100%
  border-radius 3px
  background-color #424242

</style>



// WEBPACK FOOTER //
// src/components/BaseGeofences.vue